import { useCallback, useState } from 'react';

interface IProgressBarFormValues {
  progressBarId: string | null;
  progressBarPoints: number | null;
}

interface IUseProgressBarFormReturn {
  progressBarFormValues: IProgressBarFormValues;
  setProgressBarFormValues: React.Dispatch<
    React.SetStateAction<IProgressBarFormValues>
  >;
  isProgressBarFormValid: boolean;
  dirtyProgressBar: boolean;
  handleProgressBarFormChange: (
    values: IProgressBarFormValues,
    isValid: boolean,
    isDirty: boolean
  ) => void;
}

/**
 * Manages progress bar form state and validity tracking shared
 * between Bundles and Promotions forms.
 *
 * @example
 * const { progressBarFormValues, isProgressBarFormValid, handleProgressBarFormChange } =
 *   useProgressBarForm();
 */
export const useProgressBarForm = (): IUseProgressBarFormReturn => {
  const [progressBarFormValues, setProgressBarFormValues] =
    useState<IProgressBarFormValues>({
      progressBarId: null,
      progressBarPoints: null
    });
  const [isProgressBarFormValid, setIsProgressBarFormValid] = useState(true);
  const [dirtyProgressBar, setDirtyProgressBar] = useState(false);

  const handleProgressBarFormChange = useCallback(
    (
      values: IProgressBarFormValues,
      isValid: boolean,
      isDirty: boolean
    ): void => {
      setProgressBarFormValues(values);
      setIsProgressBarFormValid(isValid);
      setDirtyProgressBar(isDirty);
    },
    []
  );

  return {
    progressBarFormValues,
    setProgressBarFormValues,
    isProgressBarFormValid,
    dirtyProgressBar,
    handleProgressBarFormChange
  };
};
